import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import questionnaireSlice from "./QuestionnaireSlice";
import registrationSlice  from "../components/Registration/RegistrationSlice";
import  userSlice from "./UserSlice";
import FormsSlice from "./FormsSlice";
import LanguageSlice from "../components/Language/LanguageSlice";
import FileUploaderSlice from "../components/FileUploader/FileUploaderSlice";
import appSlice from "./appSlice";


export const store = configureStore({
  reducer: {
    questionnaire: questionnaireSlice,
    registration: registrationSlice,
    userSlice: userSlice,
    FormsSlice:FormsSlice,
    FileUploaderSlice: FileUploaderSlice,
    languages: LanguageSlice,
    app: appSlice
  },

});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
